import { createTheme } from '@mui/material';
import commonTheme from './common';

const themeMode = 'dark';

const colors = {
  primary: {
    main: '#FFD700'
  },
  secondary: {
    main: '#1937E0'
  },
  background: {
    default: '#000000',
    paper: '#1D1B25'
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#BBBBBB'
  }
};

const customColors = {
  app: {
    colors: {
      start: '#1CB0C8',
      center: '#8F88B9',
      end: '#FF3DA3'
    }
  },
  card: {
    background: {
      primary: '#2F2D36',
      secondary: '#181818'
    }
  }
};

export const darkTheme = createTheme({
  ...commonTheme,
  custom: customColors,
  palette: {
    mode: themeMode,
    primary: {
      main: colors.primary.main
    },
    secondary: {
      main: colors.secondary.main
    },
    background: {
      default: colors.background.default,
      paper: colors.background.paper
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary
    },
    warning: {
      main: '#ed6c02'
    }
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          background: colors.background.paper
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          background: colors.background.paper
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: colors.background.paper
        }
      }
    }
  },
  shadows: [
    'none',
    '0px 1px 2px rgba(255, 255, 255, 0.1)',
    '0px 2px 4px rgba(255, 255, 255, 0.15)',
    '0px 3px 6px rgba(255, 255, 255, 0.2)',
    '0px 4px 8px rgba(255, 255, 255, 0.25)',
    '0px 5px 10px rgba(255, 255, 255, 0.3)',
    '0px 6px 12px rgba(255, 255, 255, 0.35)',
    '0px 7px 14px rgba(255, 255, 255, 0.4)',
    '0px 8px 16px rgba(255, 255, 255, 0.45)',
    '0px 9px 18px rgba(255, 255, 255, 0.5)',
    '0px 10px 20px rgba(255, 255, 255, 0.55)',
    '0px 12px 22px rgba(255, 255, 255, 0.6)',
    '0px 14px 24px rgba(255, 255, 255, 0.65)',
    '0px 16px 26px rgba(255, 255, 255, 0.7)',
    '0px 18px 28px rgba(255, 255, 255, 0.75)',
    '0px 20px 30px rgba(255, 255, 255, 0.8)',
    '0px 22px 32px rgba(255, 255, 255, 0.85)',
    '0px 24px 34px rgba(255, 255, 255, 0.9)',
    '0px 26px 36px rgba(255, 255, 255, 0.9)',
    '0px 28px 38px rgba(255, 255, 255, 0.95)',
    '0px 30px 40px rgba(255, 255, 255, 0.95)',
    '0px 32px 42px rgba(255, 255, 255, 0.95)',
    '0px 34px 44px rgba(255, 255, 255, 1)',
    '0px 36px 46px rgba(255, 255, 255, 1)',
    '0px 38px 48px rgba(255, 255, 255, 1)'
  ]
});
